import * as THREE from 'three'
import { init } from './ts/three-utils'
import vertexShader from './glsl/sphere.vert'
import fragmentShader from './glsl/sphere.frag'

const lerp = (start, end, amt) => (1 - amt) * start + amt * end

const { scene, camera, renderer } = init()
let time = 0
let timeBackwards = false

const geometry = new THREE.SphereGeometry(1, 100, 100)
const material = new THREE.ShaderMaterial({
  vertexShader,
  fragmentShader,
  uniforms: {
    time: { value: 0.0 }
  }
})
const obj = new THREE.Mesh(geometry, material)
scene.add(obj)

const light = new THREE.PointLight(0xffeedd)
light.position.set(5, 10, 20)
scene.add(light)

camera.position.z = 5

update()
function update () {
  obj.rotation.x += 0.01
  obj.rotation.z += 0.01

  if (time <= 0) timeBackwards = false
  if (time >= 1000) timeBackwards = true

  time = lerp(time, time + (timeBackwards ? -5 : 5), 0.1)
  material.uniforms.time.value = time / 100

  renderer.render(scene, camera)
  requestAnimationFrame(update)
}
